import axios from "@/utils/request"

function GET_LIST(params) {
    return axios.get("/template/ACustomTemplate/category", {
        params: {
            ...params
        }
    } )
}

function CHANG_STATUS(params) {
    return axios.post("/template/ACustomTemplate/cateStatus", {
        status:params
    })
}

export default {
    GET_LIST,
    CHANG_STATUS,
}
